"use strict";
/*
 * Created on 01 21 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DataDictionaryError_1 = require("../../../model/data-dictionary/DataDictionaryError");

var utils_1 = require("../../../utils");

var AdtFlag_1 = require("../../AdtFlag");

var EntityEvent_1 = require("../EntityEvent");

var EntityEventFlag_1 = require("../EntityEventFlag");

var EntityEventConverter_1 = require("./EntityEventConverter");
/**
 * Implementation of {@link EntityEventConverter}.
 *
 * @author Opt
 */


var EntityEventConverterImpl =
/*#__PURE__*/
function (_EntityEventConverter) {
  _inherits(EntityEventConverterImpl, _EntityEventConverter);

  function EntityEventConverterImpl() {
    _classCallCheck(this, EntityEventConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityEventConverterImpl).apply(this, arguments));
  }

  _createClass(EntityEventConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, this.serializeEntities(source.groupToEntities, conversions));
      Object.assign(result, {
        issued: conversions.fromDate(source.issued),
        event: AdtFlag_1.AdtFlag.serialize(source.event),
        processedByTasks: conversions.asObjectArray(source, 'processedByTasks', function (task) {
          return task;
        })
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new EntityEvent_1.EntityEvent(conversions.documentToClassId(source), this.deserializeEntities(source, conversions), conversions.asObject(source, 'issued', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'event', function (v) {
        return EntityEventFlag_1.EntityEventFlag.deserialize(v);
      }), conversions.asObjectList(source, 'processedByTasks', function (v) {
        return v;
      }));
    }
    /**
     * Serializes {@link EntityEvent.groupToEntities} to two arrays while ensuring order of key and value. Entity group is duplicated for
     * each entity id so deserialization is viable.
     * @param groupToEntities
     * @param conversions implementation of DataObjectConversions according data representation
     * @returns serialized {@link EntityEvent.groupToEntities}.
     */

  }, {
    key: "serializeEntities",
    value: function serializeEntities(groupToEntities, conversions) {
      return groupToEntities.reduce(function (ret, entityIds, entityGroup) {
        entityIds.forEach(function (entityId) {
          ret.entityGroups.push(entityGroup);
          ret.entityIds.push(conversions.toDocumentReferenceId(entityId));
        });
        return ret;
      }, {
        entityGroups: [],
        entityIds: []
      });
    }
    /**
     * Deserializes {@link EntityEvent.groupToEntities} to {@link EntityEvent.groupToEntities model} representation.
     * @param source the serialized document
     * @param conversions implementation of DataObjectConversions according data representation
     * @returns deserialized two arrays (entityGroups and entityIds) into {@link EntityEvent.groupToEntities}
     */

  }, {
    key: "deserializeEntities",
    value: function deserializeEntities(source, conversions) {
      if (!utils_1.Utils.isArray(source.entityGroups)) {
        throw new DataDictionaryError_1.DataDictionaryError("Value of entityGroups is not an array!");
      }

      if (!utils_1.Utils.isArray(source.entityIds)) {
        throw new DataDictionaryError_1.DataDictionaryError("Value of entityIds is not an array!");
      }

      if (source.entityIds.length !== source.entityGroups.length) {
        throw new DataDictionaryError_1.DataDictionaryError("Size of entityGroups (".concat(source.entityGroups.length, ") and entityIds (").concat(source.entityIds.length, ") differs!"));
      }

      return this.buildGroupToEntities(source.entityGroups, source.entityIds, conversions);
    }
    /**
     * @param entityGroups representation of entity groups
     * @param entityIds representation of entity ids array
     * @param conversions implementation of DataObjectConversions according data representation
     */

  }, {
    key: "buildGroupToEntities",
    value: function buildGroupToEntities(entityGroups, entityIds, conversions) {
      var result = immutable_1.Map();
      entityGroups.forEach(function (entityGroup, index) {
        var groupEntities = immutable_1.Set();

        if (result.has(entityGroup)) {
          groupEntities = result.get(entityGroup);
        }

        var entityId = entityIds[index]; // if Object (Mongo ObjectID), convert it to string

        if (entityId.toHexString) {
          entityId = entityId.toHexString();
        }

        result = result.set(entityGroup, groupEntities.add(entityId));
      });
      return result;
    }
  }]);

  return EntityEventConverterImpl;
}(EntityEventConverter_1.EntityEventConverter);

exports.EntityEventConverterImpl = EntityEventConverterImpl;